import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import arCommon from './locales/ar/common.json';
import enCommon from './locales/en/common.json';

import arHome from './locales/ar/home.json';
import enHome from './locales/en/home.json';

import arComponents from './locales/ar/components.json';
import enComponents from './locales/en/components.json';

// Initialize i18next
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ['en', 'ar'],
        resources: {
            ar: {
                common: arCommon,
                home: arHome,
                components: arComponents,
            },
            en: {
                common: enCommon,
                home: enHome,
                components: enComponents,
            }
        },
        ns: ['common', 'home', 'components'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        react: {
            useSuspense: false,
        },
        // debug: process.env.NODE_ENV === "development",
    });

export default i18n;
